'use es6';

export default ((swagger, doc) => {
  if (!swagger.paths || !doc.swagger) {
    return {
      parameters: []
    };
  }
  return swagger.paths[doc.swagger.path];
});